// Helpers de normalizacion/payload para plantillas SMARTPAY/LEGACY, paralelos a
// normalizeTemplate()/templatePayload() de ReportsPanel.jsx pero sin la logica de
// bloques/metricas (que no aplica: una plantilla LEGACY no es editable como METRICS).

// Mismo fallback explicito que el backend (resolveTemplateOriginEngine) - nunca confiar
// en que el documento ya trae origin/engine poblados (compatibilidad con plantillas viejas).
export const resolveOriginEngine = (template) => ({
  origin: (template && template.origin) || "USER",
  engine: (template && template.engine) || "METRICS",
});

export const isLegacyTemplate = (template) => resolveOriginEngine(template).engine === "LEGACY";

export function normalizeLegacyTemplate(template) {
  const id = template.id || template._id;
  const { origin, engine } = resolveOriginEngine(template);
  return {
    ...template,
    id,
    _id: template._id || template.id,
    name: template.name || "Sin nombre",
    description: template.description || "",
    origin,
    engine,
    legacy_report_code: template.legacy_report_code || null,
    filters: template.filters || {},
    updatedAt: template.updatedAt || template.updated_at || "",
  };
}

export function legacyTemplatePayload({ name, description, legacy_report_code, filters }, businessCode) {
  return {
    name,
    description: description || "",
    business_code: businessCode,
    origin: "SMARTPAY",
    engine: "LEGACY",
    legacy_report_code,
    filters: filters || {},
    blocks: [],
    source: null,
  };
}
